import { css } from "@emotion/css"

type Props = {
  children: string
  paddingTop?: number
}

const FieldDescription = ({ children, paddingTop }: Props) => {
  return (
    <div className={styles.description} style={{ paddingTop }}>
      {children}
    </div>
  )
}

export default FieldDescription

const styles = {
  description: css`
    font-size: 11px;
    color: #999999;
  `,
}
